export function cleanObject(obj, depth = 2) {
  if (depth < 0 || obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj
      .map(item => cleanObject(item, depth - 1))
      .filter(item => item !== null && item !== undefined && item !== '' && !(typeof item === 'object' && Object.keys(item).length === 0));
  }

  if (typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .map(([key, value]) => [key, cleanObject(value, depth - 1)])
        .filter(([_, value]) => {
          if (value === null || value === undefined || value === '') return false;
          if (typeof value === 'object' && Object.keys(value).length === 0) return false;
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        })
    );
  }

  return obj;
}